export const subcategoryTypes = {
  SIGNATURES: {
    PENDING: 'PENDING',
    SIGNED: 'SIGNED',
  },
};
